const signUpDefaultMessage =
  "Error occurred while completing sign up. Please contact support if the issue persists.";

export const ERROR_CODES = {
  "An account with the given email already exists.": {
    code: "EC409", // Email Conflict 409
    message: signUpDefaultMessage,
  },
  "Captcha verification failed": {
    code: "EC400CAP", // Captcha failure 400
    message: "Captcha verification failed. Please try again.",
  },
  "Code does not exist or Patient already signup": {
    code: "EC400REG", // already Registered 400
    message:
      "This referral has already been completed. If you need assistance, contact support@aptihealth.com",
  },
  "Email Address Already Referred. Please use another or contact support@aptihealth.com": {
    code: "EC409", // Email Conflict 409
    message:
      "This email has already been referred. Please use a different email or contact support@aptihealth.com",
  },
  "Email Address Already Registered. Please use another or contact support@aptihealth.com": {
    code: "EC409R", // Email Conflict 409 - already registered
    message:
      "This email is already registered. Please use a different email or contact support@aptihealth.com",
  },
  "Incomplete practice configuration": {
    code: "EPRC", // Error Practice Configuration
    message:
      "Unable to complete referral due to a practice configuration issue. Please try again or contact support@aptihealth.com.",
  },
  "Invalid Code": {
    code: "EC401C", // Invalid referral Code 401
    message: "The referral code is invalid or has already been used. Please contact your provider.",
  },
  SignUpDefault: {
    code: "EUNK", // Error Unknown
    message: signUpDefaultMessage,
  },
  "Unexpected Error": {
    code: "EC400WF", // unexpected Workflow error 400
    message:
      "An unexpected error occurred during the referral process. Please try again or contact support@aptihealth.com.",
  },
  WorkflowDefault: {
    code: "EUNK", // Error Unknown
    message: "Error updating workflow. Please try again or contact support@aptihealth.com.",
  },
};

export const DENY_LIST_EXCEPTION_TYPE = "DenyListException";
